module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "annulledMovements"
    }
  }, [(_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row pt-5"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankAccountsSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('analiseDuplicidade.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('analiseDuplicidade.labels.selecionarContasBancarias'),
      "id": "btnSelecionarContasBancarias-AnaliseDuplicidade",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-small mr-0 pb-5"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.buscar'),
      "id": "btnBuscarAnulado",
      "clickFunction": _vm.validate,
      "disabled": _vm.disableSearchButton
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2be5b59b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be5b59b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/duplicateMovementsAnalysis/annulledMovements.pug
// module id = 1388
// module chunks = 0